<template>
    <v-layout>
        <v-dialog v-model="modalpresentation" persistent style="z-index:2000" max-width="800"> 
            <v-card style=" background-color: rgba(255,255,255,0.9);border-radius: 20px;">  
                <v-container>                                
                    <v-layout style="font-size:40px;text-align:center" > 
                        <v-flex xs12>
                            <label style="font-weight: bold">{{language==='English'?'WELCOME TO HIPROYECT!':'¡BIENVENIDO A HIPROYECT!'}}<p style="color:#1976d2"> {{username}}</p></label>
                        </v-flex> 
                    </v-layout>                            
                </v-container>
                <v-layout  style="text-align:center;padding-bottom:10px">
                    <v-flex xs12 md12 lg7>
                        <v-btn @click="gotocreateproject" color="primary" style="width:90%;border-radius: 5px;" >{{language==='English'?'Create Project':'Crear Proyecto'}}</v-btn>
                    </v-flex>
                    <v-flex xs12 md12 lg5>
                        <v-btn color="secondary" @click="closemodalpresentation" style="width:90%;border-radius: 5px;" >{{language==='English'?'Omit':'Omitir'}}</v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
    </v-layout> 
</template>
<script>
import { EventBus } from '../../../helpers/eventbus/event-bus'
export default {
    data(){
        return{
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
            modalpresentation:false,
            username: ''
        }
    },
    created(){
        this.getusername()
    },
    mounted(){
        EventBus.$on('openpresentation',()=>{
            this.modalpresentation = true
        })
    },
    methods:{
        getusername(){
            let userdata = JSON.parse(localStorage.getItem('user'))
            if(userdata){
                this.username = userdata.username
            }
        },
        gotocreateproject(){
            this.$router.push('/projects')
            this.closemodalpresentation()
        },
        closemodalpresentation(){
            this.modalpresentation = false
            let getdatauser = JSON.parse(localStorage.getItem('iden'))
            if(getdatauser){
                let isnewuser = getdatauser.statususer === 'newuser'
                if(isnewuser){
                    getdatauser.statususer = 'olduser'
                    localStorage.setItem('iden',JSON.stringify(getdatauser))
                }
            }
        }
    }
}
</script>